module.exports = __webpack_public_path__ + "static/media/newUserCorp.94aa9a22.svg";